import React from 'react';
import { Map } from 'immutable';
import c from 'classnames';
import { Menu, Block } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';

import {
  Container,
  CoreLink,
} from '../../../components';

import {
  FooterSocialMenu,
  FooterKnowledgePlatformMenu,
} from '../..';

import NewsletterForm from '../../../components/NewsletterForm';
import KPNewsletterForm from '../../../components/KPNewsletterForm';
import { PARTICIPATION_BLOCK_ID } from '../../../config/constants';

import './style.scss';

const FooterMenu = ({ toggleMenu, menusToggled, id, isCampaign, campaignBlockReferenceId, campaignBlockReferenceEntity }) => {

  return (
    <Container className={`FooterMenu__inner${id ? '--campaign' : ''}`}>
      {config.get('CURRENT_DOMAIN') === 'kp'
        ? (
          <div className="row FooterMenu__kp">
            <div className="col-lg-4 col-sm-6 ">
              <FooterKnowledgePlatformMenu domainKp />
            </div>
            <div className="col-lg-4 col-sm-6">
              <KPNewsletterForm />
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="row">
                <FooterSocialMenu />
              </div>
            </div>
          </div>
        )
        : (
          <div className="row">
            <div className="FooterMenu__menus col-sm-12 col-lg-6">
              <Menu id={id || 'footer'}>
                {(items) => {
                  return (
                    <div className="row">
                      {items.map((itemUpper) => {
                        const href = itemUpper.getIn(['link', 'url'], '');
                        const title = itemUpper.getIn(['link', 'title'], 'Untitled');
                        const entityId = itemUpper.getIn(['link', 'meta_data', 'entity_id']);

                        const menuItemClasses = c('FooterMenu--hide--mobile', {
                          'FooterMenu--show--mobile': menusToggled[entityId] === true,
                        });

                        const footerTitleClasses = c('FooterMenu__title icon-after icon-arrow-down icon-variant-2', {
                          'FooterMenu__title--active': menusToggled[entityId] === true,
                        });

                        return (
                          <div className="FooterMenu__items col-sm-12 col-md-6" key={`menu--footer-${title}:${href}`}>
                            <h4 className={footerTitleClasses} onClick={() => { toggleMenu(entityId); }}>{title}</h4>
                            <div className={menuItemClasses}>
                              {itemUpper.getIn(['subtree']).map((itemLower, i) => {

                                const attrs = itemLower.getIn(['link', 'options', 'attributes'], Map());
                                const childHref = itemLower.getIn(['link', 'url'], '');
                                const childTitle = itemLower.getIn(['link', 'title'], 'Untitled');

                                return (
                                  <div key={`menu--footer--menu-item-${childTitle}:${childHref}`}>
                                    <li className="menu--footer--menu-item">
                                      <CoreLink
                                        to={childHref}
                                        target={attrs.get('target')}
                                        title={childTitle}
                                      />
                                    </li>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              </Menu>
            </div>
            <div className="FooterMenu__blocks col-sm-12 col-lg-6">
              <div className="row">

                <FooterSocialMenu />
                <div className="FooterMenu__blocks--block FooterMenu__meedoen col-sm-12 col-md-6">
                  <NewsletterForm />
                  {/* FIXME:, currently only shows nalaten on campaign pages, make dynamic. */}
                  <Block id={isCampaign ? campaignBlockReferenceId : PARTICIPATION_BLOCK_ID} buttonPrimary entity={campaignBlockReferenceEntity || null} />
                </div>
              </div>
            </div>
          </div>
        )}
    </Container>
  );
};

export default FooterMenu;
